module.exports = __webpack_public_path__ + "static/media/22-10.f32ee83d.mp3";